import { useMemo } from 'react';
import { useCategoryListQuery } from '../../features/queue/grid/defaultCellRender/CategoryRender/api/categoryQueries';
import {
  convertObjectToArray,
  filterByApplicableSrTypes,
} from '../../features/queue/grid/defaultCellRender/CategoryRender/utils';
import { CATEGORY_LIST_KEYS } from '../../features/queue/grid/constants';
import { modifyCategoriesFilter } from '../categoryUtils';

export function useModifiedCategoriesAttributes(categoryType, primaryKey, secondaryKey, srType) {
  const categories = useCategoryListQuery();

  const categoriesData = useMemo(
    () => ({
      primaryCategories: convertObjectToArray(categories?.data),
      secondaryCategories: convertObjectToArray(categories?.data?.[primaryKey]?.values),
      thirdLevelCategories: convertObjectToArray(categories?.data?.[primaryKey]?.values?.[secondaryKey]?.values),
      filteredPrimaryCategories: filterByApplicableSrTypes(convertObjectToArray(categories?.data), srType),
      filteredSecondaryCategories: filterByApplicableSrTypes(
        convertObjectToArray(categories?.data?.[primaryKey]?.values),
        srType,
      ),
      filteredThirdLevelCategories: filterByApplicableSrTypes(
        convertObjectToArray(categories?.data?.[primaryKey]?.values?.[secondaryKey]?.values),
        srType,
      ),
    }),
    [categories?.data, primaryKey, secondaryKey, srType],
  );

  const modifiedCategoriesAttributes = useMemo(() => {
    const {
      primaryCategories,
      secondaryCategories,
      thirdLevelCategories,
      filteredPrimaryCategories,
      filteredSecondaryCategories,
      filteredThirdLevelCategories,
    } = categoriesData;

    switch (categoryType) {
      case CATEGORY_LIST_KEYS.PRIMARY_LEVEL_KEY:
        return [
          modifyCategoriesFilter(primaryCategories, CATEGORY_LIST_KEYS.PRIMARY_LEVEL_KEY),
          modifyCategoriesFilter(filteredPrimaryCategories, CATEGORY_LIST_KEYS.PRIMARY_LEVEL_KEY),
        ];
      case CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY:
        return [
          modifyCategoriesFilter(secondaryCategories, CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY),
          modifyCategoriesFilter(filteredSecondaryCategories, CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY),
        ];
      case CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY:
        return [
          modifyCategoriesFilter(thirdLevelCategories, CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY),
          modifyCategoriesFilter(filteredThirdLevelCategories, CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY),
        ];
      case 'all':
        return [
          modifyCategoriesFilter(primaryCategories, CATEGORY_LIST_KEYS.PRIMARY_LEVEL_KEY),
          modifyCategoriesFilter(secondaryCategories, CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY),
          modifyCategoriesFilter(thirdLevelCategories, CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY),
          modifyCategoriesFilter(filteredPrimaryCategories, CATEGORY_LIST_KEYS.PRIMARY_LEVEL_KEY),
          modifyCategoriesFilter(filteredSecondaryCategories, CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY),
          modifyCategoriesFilter(filteredThirdLevelCategories, CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY),
        ];
      default:
        return [];
    }
  }, [categoryType, categoriesData]);

  return modifiedCategoriesAttributes;
}
